
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import Testimonials from './TestimonialKeyword';
import Accordion from './Accordion';

function Punetoakkalkotcab() {



    const cardData =
    {
        keyword: 'Pune to Akkalkot Cabs',
        heading: 'Meghana Cab : Pune to Akkalkot Cabs',
        headingDescription: 'Meghana Cab offers Pune to Akkalkot Cab services, ensuring a comfortable and devotional travel experience to the sacred Shri Swami Samarth Temple. Whether you’re visiting for religious purposes, family trips, or peaceful retreats, our experienced drivers and well-maintained vehicles guarantee a safe and smooth journey from Pune to Akkalkot. Covering around 300 kilometers, our cabs provide a convenient and relaxing ride through scenic routes. Choose from a range of AC sedans, SUVs, and tempo travellers based on your group size and budget. With punctual pickups, transparent pricing, and 24×7 customer support, Meghana Cab makes your Pune to Akkalkot travel simple, reliable, and spiritually fulfilling.',


        top: 'Top Places to Visit in Akkalkot with Meghana Cab',

"topPlaces": [
  {
    "title": "Akkalkot Swami Samarth Maharaj Temple",
    "description": "The heart of Akkalkot is the sacred temple dedicated to Shri Swami Samarth Maharaj, an incarnation of Lord Dattatreya. The temple complex is built around the famous banyan tree where Swamiji gave divine darshan to countless devotees. Pilgrims from all over India visit this temple to seek blessings, participate in daily aartis, and experience deep spiritual peace. The chanting of ‘Akkalkot Swami Maharaj Ki Jai’ echoes through the streets, creating a divine atmosphere. The temple trust also provides free meals (Anna Prasadalaya) for devotees, maintaining Swami’s legacy of compassion and service."
  },
  {
    "title": "Vatavriksha Mandir (Banyan Tree Shrine)",
    "description": "The Vatavriksha Mandir is considered the most sacred site in Akkalkot, marking the exact location where Swami Samarth Maharaj meditated and blessed his disciples. The massive banyan tree here is said to radiate divine energy and fulfill wishes of sincere devotees. Surrounding it are beautifully maintained shrines and dharmashalas. The serene chants, ringing temple bells, and scent of incense create an ambiance of pure devotion. Visiting this mandir is believed to cleanse one’s karma and bring inner calmness, making it a must-visit during your Akkalkot pilgrimage."
  },
  {
    "title": "Swami Samarth Samadhi Mandir",
    "description": "Located near the main temple complex, the Samadhi Mandir houses the final resting place of Shri Swami Samarth Maharaj. The shrine radiates divine vibrations, and devotees offer garlands, coconuts, and oil lamps as a mark of reverence. The daily Abhishek and evening Aarti are performed with great devotion, filling the air with peace. The temple walls display portraits and teachings of Swamiji that inspire countless followers. The Samadhi Mandir stands as a powerful symbol of faith, compassion, and enlightenment that continues to guide devotees even today."
  },
  {
    "title": "Akkalkot Maharaj Math",
    "description": "The Akkalkot Math serves as the administrative and spiritual center for Swami Samarth devotees. Established more than a century ago, it preserves sacred relics, manuscripts, and Swamiji’s wooden padukas. The math also manages various community service programs including education, food distribution, and accommodation for pilgrims. The premises are peaceful and ideal for meditation. Devotees often spend hours here reading Swami Charitra, a holy text that narrates his miracles. The Math upholds the timeless teachings of self-realization, humility, and universal love."
  },
  {
    "title": "Karanja Bhumi – Birthplace of Swami Samarth",
    "description": "Located about 270 km from Akkalkot in Amravati district, Karanja Bhumi is revered as the birthplace of Swami Samarth Maharaj. Pilgrims visiting Akkalkot often extend their journey here to pay homage. The temple at Karanja preserves the original house where Swamiji was born, along with sacred relics. The atmosphere of devotion and serenity at this site is palpable. Annual celebrations here draw thousands of followers. Visiting both Akkalkot and Karanja completes the spiritual circuit of Swami Samarth devotees, symbolizing his divine journey from birth to enlightenment."
  },
  {
    "title": "Akkalkot Palace and Fort",
    "description": "Beyond spirituality, Akkalkot also offers a glimpse of Maratha-era history through its old palace and fort structures. Once the seat of the Akkalkot royal family, the palace showcases elegant architecture with arches, domes, and courtyards. Though parts of it are in ruins, visitors can still sense the grandeur of its past. The fort walls stand as a reminder of the region’s strategic significance during medieval times. Exploring these heritage sites adds a historical dimension to your pilgrimage and provides a deeper understanding of Akkalkot’s royal legacy."
  },
  {
    "title": "Akkalkot Museum and Heritage Gallery",
    "description": "The Akkalkot Museum preserves the historical and spiritual legacy of the town. It features rare photographs of Swami Samarth, handwritten letters, ancient coins, and royal artifacts from the local dynasty. The museum provides visitors with insights into the evolution of Akkalkot—from a small princely state to a prominent spiritual destination. Informative exhibits, audio-visual guides, and miniature temple models make it an engaging experience for both devotees and history enthusiasts. It’s a perfect stop for understanding the cultural depth behind this sacred town."
  },
  {
    "title": "Akkalkot-Solapur Road Pilgrimage Corridor",
    "description": "The route connecting Solapur to Akkalkot is dotted with small shrines, rest stops, and scenic fields that add charm to the pilgrimage journey. Many devotees prefer to travel on foot, chanting bhajans and spreading spiritual energy along the way. The road passes through peaceful villages that showcase rural Maharashtra’s hospitality. Tea stalls, flower vendors, and local eateries serve pilgrims with warmth. Traveling this route not only leads you to Swami Samarth’s abode but also immerses you in the soulful simplicity of Maharashtrian countryside life."
  },
  {
    "title": "Hatti Hanuman Temple",
    "description": "Located near the main Swami Samarth Temple, the Hatti Hanuman Temple is a lesser-known but spiritually potent shrine. Dedicated to Lord Hanuman, it is believed that Swami Samarth himself often meditated here. The temple’s name comes from its elephant-like (‘Hatti’) idol form. Devotees visit to seek courage, strength, and protection. The temple hosts vibrant Hanuman Jayanti celebrations with kirtans and community feasts. Its proximity to the main temple makes it an easy yet enriching stop for those seeking deeper spiritual experiences in Akkalkot."
  },
  {
    "title": "Ganagapur Dattatreya Temple (Nearby)",
    "description": "Just 80 km from Akkalkot, Ganagapur in Karnataka is another highly revered Datta Peetha connected to Shri Narasimha Saraswati, an earlier incarnation of Lord Dattatreya. Many pilgrims visiting Akkalkot also visit Ganagapur to complete their Dattatreya pilgrimage. Located at the confluence of Bhima and Amarja rivers, the temple is known for its miraculous healing waters. The daily Rudrabhishek and Bhajans create an atmosphere of divinity. Visiting both Akkalkot and Ganagapur offers devotees a complete spiritual experience of the Dattatreya tradition."
  }
],

  "services": [
    {
      "name": "Pune to Akkalkot Car Rental Price",
      "description": "Check the best Pune to Akkalkot car rental prices with Meghana Cab and experience a comfortable pilgrimage journey. We provide affordable cab options including sedans, SUVs, and Innovas, perfect for families and solo travelers heading to the sacred Akkalkot Swami Samarth Temple. Our cabs are equipped with air-conditioning, experienced drivers, and door-to-door pickup and drop services. Enjoy a peaceful and comfortable drive through the scenic Solapur district while we ensure your safety and convenience. Whether you need one-way, round-trip, or multi-destination travel, Meghana Cab offers transparent pricing with no hidden costs. Book now and make your Akkalkot trip from Pune both spiritual and stress-free."
    },
    {
      "name": "Pune to Akkalkot Taxi",
      "description": "Book a reliable Pune to Akkalkot taxi with Meghana Cab for your visit to the revered Swami Samarth Temple. Our professional drivers ensure safe and timely travel along well-maintained routes. Choose from a wide range of vehicles—from economical hatchbacks to luxurious sedans and SUVs—tailored to your comfort and budget. Ideal for devotees, families, or groups, our service guarantees punctuality, clean vehicles, and smooth rides. We also provide flexible one-way and round-trip options to accommodate your darshan schedule. Experience a peaceful and comfortable Pune to Akkalkot taxi journey with Meghana Cab."
    },
    {
      "name": "Pune to Akkalkot Cabs",
      "description": "Meghana Cab offers affordable and reliable Pune to Akkalkot cab services for a hassle-free trip to the divine Swami Samarth temple. Our cabs feature comfortable seating, AC interiors, and experienced drivers familiar with pilgrimage routes. We provide customized packages for one-way trips, same-day returns, or extended stays. With transparent fares and excellent service, Meghana Cab ensures your Akkalkot pilgrimage is smooth and spiritually fulfilling. Whether you are traveling solo or with your family, our clean and well-maintained cars make every kilometer comfortable and peaceful."
    },
    {
      "name": "Pune to Akkalkot Package",
      "description": "Plan your complete Pune to Akkalkot pilgrimage package with Meghana Cab and explore the holy temple of Swami Samarth Maharaj with comfort and convenience. This package includes AC cab travel, pickup and drop from Pune, and flexible schedules suited to your darshan timings. You can also extend your trip to nearby spiritual destinations like Gangapur, Pandharpur, and Tuljapur. Our professional chauffeurs, comfortable vehicles, and affordable pricing make your spiritual journey seamless. Choose Meghana Cab’s Akkalkot package for a peaceful and well-managed devotional experience from Pune."
    },
    {
      "name": "Pune to Solapur Cab",
      "description": "Book a Pune to Solapur cab with Meghana Cab for a safe, comfortable, and affordable ride. Whether you are traveling for business, family visits, or temple darshan at Akkalkot or Pandharpur, our Solapur taxi service ensures a smooth journey. We offer multiple car options, including hatchbacks, sedans, SUVs, and Innovas, all maintained for safety and comfort. Enjoy door-to-door pickup, transparent pricing, and courteous drivers who make your intercity travel stress-free. Travel conveniently from Pune to Solapur with Meghana Cab’s reliable cab service."
    },
    {
      "name": "Pune to Pandharpur Cab",
      "description": "Travel from Pune to Pandharpur with Meghana Cab’s comfortable and dependable taxi service. Visit the famous Vithoba Temple and experience spiritual peace without travel worries. Our AC cabs, polite drivers, and flexible pickup options ensure your pilgrimage is smooth and relaxing. Whether for one-way or round-trip journeys, Meghana Cab offers clean cars, affordable fares, and punctual service. Ideal for families and devotees, our Pandharpur cab service from Pune promises a safe and soulful travel experience."
    },
    {
      "name": "Pune to Pandharpur Car Rentals",
      "description": "Rent a car from Pune to Pandharpur with Meghana Cab for an easy and comfortable temple journey. Our car rental service provides AC vehicles, experienced drivers, and full flexibility in scheduling your darshan. Whether you want an economical sedan, a spacious SUV, or a luxurious Innova, Meghana Cab offers affordable options for every traveler. Visit the holy Vithoba-Rukmini temple at your own pace, enjoy scenic drives, and travel stress-free. Book your Pune to Pandharpur car rental today and make your pilgrimage special."
    },
    {
      "name": "Pune to Pandharpur Cab Service",
      "description": "Meghana Cab offers dependable Pune to Pandharpur cab services for pilgrims and travelers visiting Lord Vitthal’s shrine. Our drivers are courteous, well-trained, and familiar with temple routes, ensuring you reach your destination safely and on time. Choose from various cab types, including AC sedans and SUVs, suitable for single travelers or large families. Our door-to-door service and flexible scheduling make your Pandharpur trip comfortable and spiritually rewarding. Experience smooth travel and affordable pricing with Meghana Cab’s Pandharpur taxi service."
    },
    {
      "name": "Pune to Pandharpur Taxi",
      "description": "Book a Pune to Pandharpur taxi with Meghana Cab for a convenient and comfortable pilgrimage experience. Our fleet of clean, air-conditioned cars and experienced drivers make your temple visit peaceful and efficient. Whether you need a one-way drop, round-trip, or group package, we have travel options suited to your budget and timing. Enjoy reliable service, punctual pickups, and easy online booking for your Pandharpur darshan from Pune. Meghana Cab ensures your devotional trip is both pleasant and memorable."
    },
    {
      "name": "Pune to Pandharpur Cab Booking",
      "description": "With Meghana Cab’s Pune to Pandharpur cab booking service, planning your Vithoba darshan has never been easier. Simply book online or by phone, choose your preferred vehicle, and enjoy door-to-door comfort. Our drivers are trained for long-distance trips and temple routes, ensuring a safe and serene journey. We offer one-way, same-day return, and custom package options to fit your needs. Book your cab today and travel from Pune to Pandharpur with peace of mind and utmost comfort."
    },
    {
      "name": "Pune to Pandharpur Cab Price",
      "description": "Get affordable Pune to Pandharpur cab prices with Meghana Cab. We offer competitive rates for one-way, round-trip, and package journeys. All our fares are transparent with no hidden costs, ensuring you get the best value for your spiritual travel. Our well-maintained cabs, professional chauffeurs, and flexible scheduling make your Pandharpur darshan journey easy and worry-free. Travel with Meghana Cab and experience comfort, reliability, and devotion all in one ride."
    },
    {
      "name": "Pune to Tuljapur Cab",
      "description": "Visit the sacred Tulja Bhavani Temple with Meghana Cab’s Pune to Tuljapur cab service. Enjoy a smooth and comfortable ride with AC cars, courteous drivers, and reliable service. Whether you’re traveling for a one-day darshan or part of a multi-temple tour, we provide flexible packages to fit your itinerary. Our drivers are familiar with temple timings and ensure timely arrival for your prayers. Book your Tuljapur cab today for a spiritual and comfortable journey from Pune."
    },
    {
      "name": "Pune to Tuljapur Cab Fare",
      "description": "Check the best Pune to Tuljapur cab fares with Meghana Cab and plan your temple visit affordably. Our transparent pricing and comfortable cabs make your Tulja Bhavani darshan convenient and enjoyable. Choose from sedans, SUVs, or Innovas based on your group size and budget. With experienced drivers and punctual service, we ensure a peaceful trip from Pune to Tuljapur and back. Book online to secure your journey at the best price today."
    },
    {
      "name": "Pune to Tuljapur Car Rentals",
      "description": "Rent a car from Pune to Tuljapur with Meghana Cab for a flexible and comfortable temple visit. Our car rental services include air-conditioned vehicles, safe drivers, and customizable packages. Ideal for family pilgrimages or weekend getaways, the Pune to Tuljapur route is handled smoothly by our expert chauffeurs. We also offer extended darshan packages including Pandharpur and Akkalkot. Experience reliable and affordable travel with Meghana Cab’s Tuljapur car rentals."
    },
    {
      "name": "Akkalkot Gangapur Tuljapur Pandharpur Package from Pune",
      "description": "Explore the sacred temples of Maharashtra with Meghana Cab’s Akkalkot–Gangapur–Tuljapur–Pandharpur tour package from Pune. This all-in-one pilgrimage covers key spiritual destinations including Swami Samarth Temple (Akkalkot), Shri Dattatreya Temple (Gangapur), Tulja Bhavani Temple (Tuljapur), and Lord Vitthal Temple (Pandharpur). Enjoy AC cab travel, safe drivers, comfortable seating, and door-to-door pickup and drop service. We provide flexible itineraries, affordable rates, and experienced drivers familiar with all temple routes. Perfect for families and devotees seeking a complete spiritual journey, this package ensures peace, comfort, and devotion throughout your tour."
    },
    {
      "name": "Pune to Gangapur Cabs",
      "description": "Book a Pune to Gangapur cab with Meghana Cab and visit the sacred Dattatreya temple with ease and comfort. Our AC taxis and experienced drivers ensure a smooth, safe journey through scenic Maharashtra routes. Ideal for devotees visiting both Akkalkot and Gangapur in a single trip, we offer flexible schedules and customizable packages. Choose from a variety of car options to suit your budget and group size. Meghana Cab guarantees punctual service, clean vehicles, and a peaceful spiritual journey from Pune to Gangapur."
    },
    {
      "name": "Pune to Akkalkot Darshan",
      "description": "Plan your Pune to Akkalkot Darshan trip with Meghana Cab for a serene and devotional experience. Visit the holy Swami Samarth Maharaj Temple comfortably in our AC cabs with professional drivers. We offer one-way, same-day return, and extended pilgrimage packages that include Gangapur, Pandharpur, and Tuljapur. Enjoy smooth rides, flexible timing, and affordable fares as you focus on your spiritual journey. Book your Akkalkot Darshan cab from Pune with Meghana Cab and experience devotion made comfortable."
    }
  ],

  "tableData": [
    ["Pune to Akkalkot Car Rental Price", "Pune to Akkalkot Taxi"],
    ["Pune to Akkalkot Cabs", "Pune to Akkalkot Package"],
    ["Pune to Solapur Cab", "Pune to Pandharpur Cab"],
    ["Pune to Pandharpur Car Rentals", "Pune to Pandharpur Cab Service"],
    ["Pune to Pandharpur Taxi", "Pune to Pandharpur Cab Booking"],
    ["Pune to Pandharpur Cab Price", "Pune to Tuljapur Cab"],
    ["Pune to Tuljapur Cab Fare", "Pune to Tuljapur Car Rentals"],
    ["Akkalkot Gangapur Tuljapur Pandharpur Package from Pune", "Pune to Gangapur Cabs"],
    ["Pune to Akkalkot Darshan", ""]
  ],











"whychoose": [
    {
        "WhyChooseheading": "Reliable Pune to Akkalkot Cab Service",
        "WhyChoosedescription": "Meghana Cab offers dependable cab services from Pune to Akkalkot, ensuring a comfortable journey to the sacred land of Shri Swami Samarth Maharaj."
    },
    {
        "WhyChooseheading": "Timely Pick-Up and Drop at Akkalkot",
        "WhyChoosedescription": "We guarantee punctual pick-up from Pune and timely drop-off at Akkalkot, so you can attend darshan or spiritual rituals without any travel delays."
    },
    {
        "WhyChooseheading": "Experienced Drivers for Devotional Routes",
        "WhyChoosedescription": "Our professional drivers are familiar with the Pune to Akkalkot route and temple schedules, making your religious trip smooth, safe, and convenient."
    },
    {
        "WhyChooseheading": "Affordable Pune to Akkalkot Cab Fare",
        "WhyChoosedescription": "Meghana Cab provides budget-friendly rates for your Pune to Akkalkot journey, with transparent pricing and no hidden fees—perfect for pilgrimage travel planning."
    },
    {
        "WhyChooseheading": "Safe and Clean Vehicles for Your Journey",
        "WhyChoosedescription": "Travel with peace of mind in our sanitized and well-maintained cabs, equipped with safety features like GPS, seat belts, and emergency support."
    },
    {
        "WhyChooseheading": "24/7 Cab Availability for Akkalkot Trips",
        "WhyChoosedescription": "Whether you're planning an early morning darshan or a late evening return, our cab services from Pune to Akkalkot are available round-the-clock to suit your schedule."
    },
    {
        "WhyChooseheading": "Custom Travel Options for Pilgrims",
        "WhyChoosedescription": "We offer one-way, round-trip, and customizable packages for Pune to Akkalkot, allowing flexibility in planning your spiritual visit."
    },
    {
        "WhyChooseheading": "Simple Online Booking and Devotee Support",
        "WhyChoosedescription": "Book your cab easily through our website or app. Need help with your Akkalkot travel? Our support team is always available to assist you with bookings and trip queries."
    }
]




















    }

const faqData = [
    {
        question: "How can I book a Pune to Akkalkot cab with Meghana Cab?",
        answer: "You can book a Pune to Akkalkot cab easily through Meghana Cab’s website or by calling our customer service at +91 9075462128."
    },
    {
        question: "What are the cab options available for Pune to Akkalkot travel?",
        answer: "Meghana Cab offers a range of vehicles including hatchbacks, sedans, SUVs, and tempo travellers depending on your group size and comfort needs."
    },
    {
        question: "Is one-way cab service available from Pune to Akkalkot?",
        answer: "Yes, Meghana Cab provides both one-way and round-trip cab services from Pune to Akkalkot."
    },
    {
        question: "How long does it take to travel from Pune to Akkalkot by cab?",
        answer: "The journey from Pune to Akkalkot takes approximately 6 to 7 hours, depending on traffic and road conditions."
    },
    {
        question: "Are tolls and parking charges included in the Pune to Akkalkot cab fare?",
        answer: "Tolls, parking fees, and taxes are additional and clearly mentioned during the booking process."
    },
    {
        question: "Are Meghana Cab drivers experienced for outstation routes like Pune to Akkalkot?",
        answer: "Yes, all our drivers are experienced and well-versed with routes to religious destinations like Akkalkot."
    },
    {
        question: "Can I schedule stops or breaks on the way to Akkalkot?",
        answer: "Yes, you can request custom stops or breaks during the journey. Please mention them while booking."
    },
    {
        question: "Is the cab service from Pune to Akkalkot available at night?",
        answer: "Yes, we offer 24/7 cab services. You can schedule a day or night journey as per your convenience."
    },
    {
        question: "What are the payment options for booking a Pune to Akkalkot cab?",
        answer: "We accept UPI, credit/debit cards, net banking, and cash payments."
    },
    {
        question: "How do I contact Meghana Cab for Pune to Akkalkot bookings?",
        answer: "For bookings and queries, please call Meghana Cab at +91 9075462128."
    }
];

const testimonialsData = [
    {
        name: 'Mr. Ravi Shinde',
        designation: 'Customer',
        rating: [1, 1, 1, 1, 1],
        text: '“Our visit to Akkalkot Swami Samarth Mandir was very smooth thanks to Meghana Cab. The driver was polite, punctual, and familiar with the route.”',
    },
    {
        name: 'Mrs. Vaishali Patil',
        designation: 'Customer',
        rating: [1, 1, 1, 1, 1],
        text: '“Booked a cab to Akkalkot for my parents. The service was safe and timely. Very happy with Meghana Cab’s support and driver behavior.”',
    },
];











































    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 9075462128",
            "+91 8452916550",

        ],
        email: "booking@meghanacabs.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Online Cab Booking in Pune",
        },
        {
            place: "/images/keyword/2.jpg",
            text: "Pune to Kolhapur Cab",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Pune to Satara Cab",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Pune to Hyderabad Cab",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "Pune to Bangalore Cab",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "Pune to Indore Cab",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Pune to Gujarat Cab",
        },

        {
            place: "/images/keyword/8.jpg",
            text: "Pune to Lonavala Taxi",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Pune to Jejuri Cab",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Local Taxi Service in Pune",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Pune to Lavasa Cab",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Pune to Kashid Beach Cab",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "One Way Cab Pune",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Round Trip Cab",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Taxi Service Near Me",
        },
        {
            place: "/images/keyword/16.jpg",
            text: " Car Hire in Pune",
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Seater Car on Rent in Pune",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Cab Service in Pimpri Chinchwad",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Pune Taxi Cab Services",
        },
        {
            place: "/images/keyword/20.jpg",
            text: "Pune Airport Taxi",
        },

        {
            place: "/images/keyword/21.jpg",
            text: "Pune to Rajasthan Cab",
        },
        {
            place: "/images/keyword/22.jpg",
            text: "Pune to Matheran Cab",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Pune to Pandharpur Cab",
        },
        {
            place: "/images/keyword/24.jpg",
            text: " Pune to Mumbai Cabs",
        },
        {
            place: "/images/keyword/25.jpg",
            text: "Pune to Mumbai Airport Cab ",
        },
        {
            place: "/images/keyword/26.jpg",
            text: " Pune to Mumbai Taxi",
        },
    ];


    const images = [
        { src: "/images/booking/1.jpg", alt: "Image 1" },
        { src: "/images/booking/5.jpg", alt: "Image 1" },
        { src: "/images/booking/2.jpg", alt: "Image 1" },
        { src: "/images/booking/3.jpg", alt: "Image 1" },
        { src: "/images/booking/4.jpg", alt: "Image 1" },
        { src: "/images/booking/7.jpg", alt: "Image 1" },
        { src: "/images/booking/8.jpg", alt: "Image 1" },
        { src: "/images/booking/9.jpg", alt: "Image 1" },
        { src: "/images/booking/6.jpg", alt: "Image 1" },

    ];









const jsonData = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Pune to Akkalkot Cabs",
  "description": "Affordable and reliable Pune to Akkalkot cab service by Meghana Cabs. Comfortable car rentals and taxi packages covering Akkalkot, Solapur, Pandharpur, Tuljapur, and Gangapur. Book your cab for seamless travel and darshan tours.",
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "3820"
  }
};


    return (
        <div>



<Helmet>
  <title>Pune to Akkalkot Cabs | Best Taxi & Car Rental Service @ Meghana Cabs</title>
  <meta
    name="description"
    content="Book Pune to Akkalkot cabs with Meghana Cabs. Reliable taxi and car rental services covering Akkalkot, Solapur, Pandharpur, Tuljapur, and more. Affordable packages for comfortable travel."
  />
  <meta
    name="keywords"
    content="pune to akkalkot car rental price, pune to akkalkot taxi, pune to akkalkot cabs, pune to akkalkot package, pune to solapur cab, pune to pandharpur cab, Pune to pandharpur car rentals, Pune to pandharpur cab service, Pune to pandharpur taxi, pune to pandharpur cab booking, pune to pandharpur cab price, pune to tuljapur cab, pune to tuljapur cab fare, pune to tuljapur car rentals, akkalkot gangapur tuljapur pandharpur package from pune, pune to gangapura cabs, pune to Akkalkot Darshan"
  />
  <script type="application/ld+json">
    {JSON.stringify(jsonData)}
  </script>
</Helmet>




            <section className="page-title centred">
                <div className="bg-layer" style={{ backgroundImage: 'url(/images/page-header-bg.jpg)' }}></div>
                <div className="auto-container">
                    <div className="content-box">

                        <h1>{cardData.keyword}</h1>
                    </div>
                </div>
            </section>




            <section>
                <div className="container-fluid" >
                    <div className="row ">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/57.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#F2614C', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                             <h3 className='pt-md-3 text-dark'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                <h2 className='whycolor py-3'>Why Choose us for  {cardData.keyword}</h2>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark darkcolor">FAQS {cardData.keyword} For Meghana Cabs </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">
                                                <Accordion data={faqData} />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <Testimonials testimonials={testimonialsData} />


                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3 className=' text-dark'>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #F1604F',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#F1604F' }}>
                                            <h4 className=" lead fw-semibold whitt text-darkk">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+919075462128" className="d-block  text-white">+91 9075462128</a>
                                                <a href="tel:+918452916550" className="d-block  text-white">+91 8452916550</a>



                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#F1604F' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Email</h4>
                                                <a href="mailto:booking@meghanacabs.com" className=" text-white d-block">
                                                    booking@meghanacabs.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#F1604F' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Meghana Cab  <br />
                                                        Yelwande Wasti. Opp Vithal Lawans, Laxmi Chowk, Hinjawadi, Pune - 411057
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Punetoakkalkotcab;